module.exports = __webpack_public_path__ + "static/media/road5.3d31ca92.png";